<template>
  <div v-if="currentUser !== null" class="jd-list-wrapper">
    <div v-if="loading || isSubmitting || isLoading" class="loader-container">
      <Loader />
    </div>
    <section class="catg-area ptop-5" ref="jdListContainer" v-else>
      <div class="container">
        <!-- Top controls: Toggle and Search -->
        <div class="top-controls d-flex align-items-center mt-3" style="margin-bottom: 12px;">
          <div class="toggle-container d-flex align-items-center">
            <label class="" style="margin: 0 8px 0 0;color: #000000 !important;">AIによるマッチ求人のみ表示</label>
            <toggle-button
              v-model="userBasedMatching"
              :sync="true"
              @change="handleToggle"
            />
          </div>
          <div 
            class="search-container d-flex align-items-center tooltip-container" 
            :class="{ 'search-disabled': userBasedMatching }"
          >
            <div class="search-input-wrapper">
              <i class="fa fa-search search-icon"></i>
              <input
                type="text"
                name="jd_search"
                v-model="currentSearchQuery"
                placeholder="キーワード"
                class="search-input"
                @keyup.enter="handleSearch"
                :disabled="userBasedMatching"
              />
              <button
                type="button"
                class="search-button"
                @click="handleSearch"
                :disabled="userBasedMatching"
              >
                検索
              </button>
            </div>
            <div v-if="userBasedMatching" class="custom-tooltip">
              AIによる求人表示をONにすると求人検索はできません
            </div>
          </div>
        </div>

        <template v-if="applicantJD">
          <JDRow
            :jd="applicantJD"
            :jdClass="'highlighted'"
            :isSubmitting="isSubmitting"
            @openJdInfo="openJdInfo"
            @matchJd="toggleJDMatch"
            :profile="applicantProfile"
            :radioName="'jd_select'"
          />
        </template>

<!-- 
        <template v-if="!userBasedMatching">
          <JDRow
            v-for="jd in scoutedItems"
            :key="jd._id"
            :jd="jd"
            :isSubmitting="isSubmitting"
            @openJdInfo="openJdInfo"
            @matchJd="toggleJDMatch"
            :profile="applicantProfile"
            :applicantJD="applicantJD"
            :radioName="'scouted_jd_select'"
          />
        </template> -->

        <JDRow
          v-for="jd in displayedOtherItems"
          :jd="jd"
          :key="jd._id"
          :isSubmitting="isSubmitting"
          @openJdInfo="openJdInfo"
          @matchJd="toggleJDMatch"
          :profile="applicantProfile"
          :radioName="'jd_select'"
        />

        <div class="pagination-area" v-if="totalPages > 1">
          <GlobalPaginate
            :total-page="totalPages"
            :callback="handlePageChange"
            :currentPage="currentPage"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import ApiService from '@/service/apiService';
import GlobalPaginate from '@/components/utils/GlobalPaginate.vue';
import Loader from '../../../../utils/Loader.vue';
import Api from '@/config/api';
import moment from 'moment';
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex';
import JDRow from './JDRow.vue';

export default {
  name: 'JDList',
  components: { JDRow, GlobalPaginate, Loader },
  props: ['applicantId', 'items', 'isLoading'],
  data() {
    return {
      allJDs: [],
      clientPage: 1,
      pageNumber: 1,
      loading: false,
      isSubmitting: false,
      pageSize: 100,
    };
  },
  methods: {
    ...mapMutations({
      setProfileView: 'setProfileView',
      setPreservedState: 'profileJd/setPreservedState',
      setUserBasedMatching: 'setUserBasedMatching',
      setJdSearch: 'profileJd/setJdSearch',
      setSearchType: 'profileJd/setSearchType',
      setServerPage: 'profileJd/setServerPage',
      setServerTotalPages: 'profileJd/setServerTotalPages',
      setJdSearch: 'profileJd/setJdSearch',
      setSearchType: 'profileJd/setSearchType',
      setServerJds: 'profileJd/setServerJds',
      setRecommendedJds: 'profileJd/setRecommendedJds',
      setFilteredJds: 'profileJd/setFilteredJds',
      setUserBasedSearchConditions: 'profileJd/setUserBasedSearchConditions',
      setServerSearchConditions: 'profileJd/setServerSearchConditions',
    }),
    ...mapActions({
      toggleJobseekerSelection: 'toggleJobseekerSelection',
    }),
    async handlePageChange(page) {
      if (this.userBasedMatching) {
        this.clientPage = page;
      } else {
        await this.loadServerJDs(this.buildParams(page));
      }
      this.scrollToTop();
    },
    async handleToggle({ value }) {
      this.setUserBasedMatching(value);
      if (value && !this.filteredJDs.length > 0) {
        await this.loadRecommendedJDs();
      } else if (!value && !this.serverJDs.length > 0) {
        await this.loadServerJDs(this.buildParams(1));
      }
    },
    handleSearch() {
      if (this.userBasedMatching) {
        if (!this.currentSearchQuery.trim()) {
          let filteredJDs = [...this.recommendedJDs].filter((jd) =>
            this.applicantJD ? jd._id !== this.applicantJD._id : true
          );
          this.setFilteredJds(filteredJDs);
        } else {
          const searchTerms = this.currentSearchQuery
            .toLowerCase()
            .split(/[,\s]+/)
            .filter((term) => term);
          const jdToFilter = this.recommendedJDs;
          let filteredJDs = jdToFilter
            .filter((item) => {
              const itemText = [
                item.job_title,
                item.location,
                item.job_description,
              ]
                .join(' ')
                .toLowerCase();

              return this.currentSearchType === 'all'
                ? searchTerms.every((term) => itemText.includes(term))
                : searchTerms.some((term) => itemText.includes(term));
            })
            .filter((jd) =>
              this.applicantJD ? jd._id !== this.applicantJD._id : true
            );
          this.setFilteredJds(filteredJDs);
        }
        this.clientPage = 1;
      } else {
        this.loadServerJDs(this.buildParams(1));
        this.setServerPage(1);
      }
    },

    async loadRecommendedJDs() {
      this.loading = true;
      try {
        const response = await ApiService.get(
          Api.endpoints.USER_BASED_MATCHING(this.applicantId, { isNewPanel: true})
        );
        const recommendedData = response.data.data;

        if (!recommendedData || recommendedData.length === 0) {
          // No recommended JDs found, fallback to server JDs
          this.setUserBasedMatching(false); // Update toggle state

          await this.loadServerJDs(this.buildParams(1));
          return;
        }
        // const newRecommendedData = recommendedData.slice(0, 5);
        this.setRecommendedJds(recommendedData);
        // this.recommendedJDs = recommendedData;
        // this.setFilteredJds(this.applicantId);

        let filteredJDs = [...this.recommendedJDs].filter((jd) =>
          this.applicantJD ? jd._id !== this.applicantJD._id : true
        );
        this.setFilteredJds(filteredJDs);
        // this.hasLoadedRecommended = true;
      } catch (error) {
        console.error('Error loading recommended JDs:', error);
        // On error, fallback to server JDs
        this.setUserBasedMatching(false);

        await this.loadServerJDs(this.buildParams(1));
      } finally {
        this.loading = false;
      }
    },

    async loadServerJDs(params = {}) {
      this.loading = true;
      try {
        const response = await ApiService.get(
          Api.endpoints.ALL_JDS,
          {},
          params
        );

        const { jDs, totalPages } = response.data.data;
        this.setServerJds(jDs);
        this.setServerTotalPages(totalPages);
        this.setServerPage(params.page);
      } finally {
        this.loading = false;
      }
    },

    async getMatchedJDs() {
      try {
        const response = await ApiService.get(
          Api.endpoints.USER_BASED_MATCHING(this.applicantId)
        );
        return response.data.data;
      } catch (err) {
        console.error('Error fetching matched JDs:', err);
        return null;
      }
    },

    async toggleJDMatch(jd, unselect) {
      this.isSubmitting = true;
      try {
        const data = {
          // eligibility: true,
          jobseekerId: this.applicantId,
          // matching_score: 0,
        };
        data.timestamp = moment().format('YYYY-MM-DD HH:mm');

        await this.toggleJobseekerSelection({
          jd,
          unselect,
          id: this.applicantId,
          data,
        });
        if (this.userBasedMatching) {
          if (unselect) {
            // When unselecting, add the JD back to the filtered list
            let jds = [...this.filteredJDs];
            jds.push(jd);
            this.setFilteredJds(jds);
          } else {
            let jds = [...this.recommendedJDs];
            const filteredJds = jds.filter(
              (jD) => jD._id !== jd._id
            );
            this.setFilteredJds(filteredJds);
            // const filteredJDs = this.filteredJDs.filter(
            //   (jD) => jD._id !== jd._id
            // );
            // this.setFilteredJds(filteredJDs);
          }
          this.clientPage = 1;
        } else {
          this.loadServerJDs(this.buildParams(1));
        }
        this.isSubmitting = false;
      } catch (err) {
        console.log(err);
        this.isSubmitting = false;
        this.parseErrorResponse(err.response);
      }
    },
    formatDate(date) {
      return moment(date).format('YYYY/MM/DD');
    },
    buildParams(page = 1) {
      const params = { page };

      // Add jobseekerId if available
      if (this.applicantId) {
        params.jobseekerId = this.applicantId;
      }

      const currentConditions = this.userBasedMatching
        ? this.userBasedSearchConditions
        : this.serverSearchConditions;

      if (currentConditions.jdSearch && currentConditions.jdSearch.trim()) {
        if (currentConditions.searchType === 'all') {
          params.jdSearchAnd = currentConditions.jdSearch;
        } else {
          params.jdSearchOr = currentConditions.jdSearch;
        }
      }

      if (this.applicantJD && this.applicantJD._id) {
        params.excludeJD = this.applicantJD._id;
      }

      return params;
    },

    matchJd(jd, unselect) {
      this.$emit('matchJd', jd, unselect);
    },
    openJdInfo(jd) {
      const scrollPosition = this.$refs.jdListContainer.scrollTop || 0;
      this.setProfileView({
        view: 'jdInfo',
        individualJD: jd,
        applicantJD: this.applicantJD,
        userBasedMatching: this.userBasedMatching,
      });
      this.setPreservedState({
        scrollPosition,
      });
    },
    scrollToTop() {
      this.$nextTick(() => {
        const modalBody = document.querySelector('.modal-body');
        const tableHeader =
          modalBody && modalBody.querySelector('.catg-area thead');

        if (tableHeader) {
          tableHeader.scrollIntoView({
            behavior: 'auto',
            block: 'start',
          });
        }
      });
    },
  },
  computed: {
    ...mapGetters({
      currentUser: 'getCurrentUser',
      listAllJds: 'getListAllJds',
      getUserBasedMatching: 'getUserBasedMatching',
      profileView: 'getProfileView',
      serverPage: 'profileJd/getServerPage',
      serverTotalPages: 'profileJd/getServerTotalPages',
      getJdSearch: 'profileJd/getJdSearch',
      getSearchType: 'profileJd/getSearchType',
    }),
    ...mapState({
      applicantJD: ({ applicant }) => applicant.applicantJD,
      applicantProfile: ({ applicant }) => applicant.profile,
      preservedState: ({ profileJd }) => profileJd.preservedState,
      // userBasedMatching: ({applicant}) => applicant.userBasedMatching,
      storedPageNumber: ({ applicant }) => applicant.currentJDListPage,
      serverJDs: ({ profileJd }) => profileJd.serverJDs,
      recommendedJDs: ({ profileJd }) => profileJd.recommendedJDs,
      filteredJDs: ({ profileJd }) => profileJd.filteredJDs,
      userBasedSearchConditions: ({ profileJd }) =>
        profileJd.userBasedSearchConditions,
      serverSearchConditions: ({ profileJd }) =>
        profileJd.serverSearchConditions,
    }),

    currentSearchQuery: {
      get() {
        return this.userBasedMatching
          ? this.userBasedSearchConditions.jdSearch
          : this.serverSearchConditions.jdSearch;
      },
      set(value) {
        if (this.userBasedMatching) {
          this.setUserBasedSearchConditions({
            ...this.userBasedSearchConditions,
            jdSearch: value,
          });
        } else {
          this.setServerSearchConditions({
            ...this.serverSearchConditions,
            jdSearch: value,
          });
        }
      },
    },

    currentSearchType: {
      get() {
        return this.userBasedMatching
          ? this.userBasedSearchConditions.searchType
          : this.serverSearchConditions.searchType;
      },
      set(value) {
        if (this.userBasedMatching) {
          this.setUserBasedSearchConditions({
            ...this.userBasedSearchConditions,
            searchType: value,
          });
        } else {
          this.setServerSearchConditions({
            ...this.serverSearchConditions,
            searchType: value,
          });
        }
      },
    },

    jdSearch: {
      get() {
        return this.getJdSearch;
      },
      set(value) {
        this.setJdSearch(value);
      },
    },
    searchType: {
      get() {
        return this.getSearchType;
      },
      set(value) {
        this.setSearchType(value);
      },
    },
    userBasedMatching: {
      get() {
        return this.getUserBasedMatching;
      },
      set(value) {
        this.setUserBasedMatching(value);
      },
    },
    currentPage() {
      return this.userBasedMatching ? this.clientPage : this.serverPage;
    },
    totalPages() {
      if (this.userBasedMatching) {
        return Math.ceil(this.filteredJDs.length / this.pageSize);
      }
      return this.serverTotalPages;
    },

    jdMatchingAuthority() {
      return this.currentUser && this.currentUser.jdMatchingAuthority;
    },
    displayedItems() {
      if (this.userBasedMatching) {
        const start = (this.clientPage - 1) * this.pageSize;
        const end = start + this.pageSize;
        return this.filteredJDs.slice(start, end);
      }
      return this.serverJDs;
    },
    scoutedItems() {
      // Get the scouted jobs from applicant profile
      const scoutedJobs = this.applicantProfile && this.applicantProfile.scouted_jobs
        ? this.applicantProfile.scouted_jobs
        : [];

      // Transform to match the expected structure
      const transformedJobs = scoutedJobs.map(scoutedJob => ({
        _id: scoutedJob.jobDetails._id,
        job_title: scoutedJob.jobDetails.job_title,
        company: scoutedJob.jobDetails.company,
        location: scoutedJob.jobDetails.location || '',
        qualification: scoutedJob.jobDetails.job_description || '',
        job_description: scoutedJob.jobDetails.job_description,
        jd_url: scoutedJob.jobDetails.jd_url,
        highlights: scoutedJob.jobDetails.highlights || [],
        // Add any other properties that JDRow expects
        isScouted: true, // Flag to identify this as a scouted JD
        scoutedJobId: scoutedJob._id, // Keep reference to original scouted job
        scoutedStatus: scoutedJob.status // Keep status for sorting
      }));

      // Sort by status: active first, then expired
      return [...transformedJobs].sort((a, b) => {
        // Active status gets priority 1, expired gets priority 2
        const getPriority = (status) => {
          if (status === 'active') return 1;
          if (status === 'expired') return 2;
          return 3; // Unknown status
        };
        
        const priorityA = getPriority(a.scoutedStatus);
        const priorityB = getPriority(b.scoutedStatus);
        return priorityA - priorityB;
      });
    },
    displayedOtherItems() {
      return  this.displayedItems;
      const scoutedIds = new Set(
        (this.applicantProfile && this.applicantProfile.scouted_jobs
          ? this.applicantProfile.scouted_jobs
          : []
        ).map((s) => s.job)
      );

      // Exclude scouted jobs from the main displayed list
      return this.displayedItems.filter((jd) => !scoutedIds.has(jd._id));
    },
    filteredRecommendedJDs() {
      if (!this.shouldFilter || !this.jdSearch.trim()) {
        return this.recommendedJDs.filter((jd) =>
          this.applicantJD ? jd._id !== this.applicantJD._id : true
        );
      }

      const searchTerms = this.jdSearch
        .toLowerCase()
        .split(/[,\s]+/)
        .filter((term) => term);
      return this.recommendedJDs
        .filter((item) => {
          const itemText = [item.job_title, item.location, item.job_description]
            .join(' ')
            .toLowerCase();

          return this.searchType === 'all'
            ? searchTerms.every((term) => itemText.includes(term))
            : searchTerms.some((term) => itemText.includes(term));
        })
        .filter((jd) =>
          this.applicantJD ? jd._id !== this.applicantJD._id : true
        );
    },
  },
  mounted() {
    this.changeBodyBackground();
  },

  async created() {
    // this.loadExistingDatas();
    // Initial load based on current mode
    if (this.userBasedMatching && !this.filteredJDs.length > 0) {
      await this.loadRecommendedJDs();
    } else if (!this.userBasedMatching && !this.serverJDs.length > 0) {
      await this.loadServerJDs(this.buildParams(1));
    }
  },

  watch: {
    profileView: {
      handler(newView, oldView) {
        if (newView === 'jdList') {
          // Coming back from JDInfo
          this.$nextTick(() => {
            if (this.$refs.jdListContainer && this.preservedState) {
              this.$refs.jdListContainer.scrollTop =
                this.preservedState.scrollPosition || 0;
            }
          });
        }
      },
      immediate: true,
    },
    // applicantJD: {
    //   handler(newVal, oldVal) {
    //     if (newVal && newVal._id && (!oldVal || oldVal._id !== newVal._id)) {
    //       if (this.userBasedMatching) {
    //         // For client-side (recommended JDs)
    //           // Filter out the applicantJD from filteredJDs
    //           const filteredJDs = this.recommendedJDs.filter(jd => jd._id !== newVal._id);
    //           this.setFilteredJds(filteredJDs);
    //           this.clientPage = 1;
    //       } else {
    //         this.loadServerJDs(this.buildParams(1));
    //       }
    //     }
    //   },
    //   immediate: true
    // },

    storedPageNumber(newVal) {
      if (newVal !== this.pageNumber) {
        this.pageNumber = newVal;
        this.updatePagination();
      }
    },
  },
};
</script>

<style scoped>
.toggle-container {
  margin-right: 10px;
  background: #fff;
  border-radius: 8px;
  height: 43px;
  width: 235px;
  flex-shrink: 0;
}
.jd-list-wrapper {
  height: 84vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: #EBEFF1;
}

.jd-header {
  flex: 0 0 auto;
  padding: 2px;
  margin-top: 10px;
  width: 100%;
  background: #fff;
  border-radius: 10px;
  height: 53px;
}

.catg-area,
.loader-container {
  flex: 1 1 0%;
  overflow: auto;
  overflow-x: hidden;
  min-height: 0;
  position: relative;
  display: flex;
  align-items: flex-start;
}

.loader-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.list-button {
  min-width: 100px;
  background: #006c6b;
  padding: 5px 20px !important;
  border-radius: 0px !important;
  font-size: 12px;
}

.text-center {
  text-align: center !important;
}

.matchButton {
  width: 10%;
  background: #fff !important;
  border: 2px solid white !important;
  vertical-align: middle;
}

.jd-header p {
  font-size: 24px;
  font-weight: 600;
  margin: auto;
  padding: 10px;
}

.ptop-5 {
  padding-top: 5px !important;
}

label {
  color: #3c3c3c;
  padding: 5px;
  margin-top: 10px;
  font-size: 12px;
  font-weight: 400;
}
.top-controls {
  width: 100%;
  justify-content: space-between;
}

.search-container {
  flex: 1;
  height: 43px;
  background: #fff;
  border-radius: 8px;
  max-width: 360px !important;
  position: relative;
}

.search-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  margin-right: 10px;
  width: 100%;
}

.search-icon {
  position: absolute;
  left: 12px;
  color: #7a7e82;
  font-size: 14px;
  z-index: 1;
  pointer-events: none;
}

.search-input {
  padding: 0 25px 0 40px;
  flex: 1;
  height: 28px;
  border: none !important;
  border-right: none;
  border-radius: 4px;
  font-size: 14px;
  color: #7a7e82;
  box-sizing: border-box;
}

.search-input::placeholder {
  color: #979B9F;
  font-size: 12px;
}

.search-input:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.search-button:disabled {
  opacity: 0.6;
}

.search-disabled .search-input-wrapper {
  opacity: 0.6;
}

.search-button {
  min-width: 100px;
  height: 28px;
  border-radius: 4px;
  padding: 0 25px;
  background: #4F46E5;
  color: #fff;
  border: 1px solid #4F46E5;
  border-left: none;
  font-size: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  white-space: nowrap;
  box-sizing: border-box;
  font-weight: bold;
}

.search-button:hover:not(:disabled) {
  background: #4338ca;
  border-color: #4338ca;
}

.search-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.search-input:focus {
  outline: none;
  border: 1px solid #7a7e82;
  border-right: none;
}

.table {
  /* border-collapse: collapse; */
  width: 100%;
  font-size: 12px;
}

.table th,
tr {
  border: 2px solid #c4c4c4;
}

.table th {
  /* padding: 30px 10px 20px 10px; */
  padding: 5px;
  text-align: center;
  border-bottom: 1px solid black;
  font-size: 14px;
  color: #fff;
}

thead {
  background-color: #787878;
}

.collapse-icon {
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  user-select: none;
  min-width: 20px;
  text-align: center;
  margin-right: 40px; 
}

/* Custom Tooltip Styles */
.tooltip-container {
  position: relative;
  display: inline-block;
}

.custom-tooltip {
  visibility: hidden;
  opacity: 0;
  background-color: #787878;
  color: white;
  text-align: center;
  border-radius: 10px;
  padding: 8px 12px;
  position: absolute;
  z-index: 1000;
  top: 125%;
  left: 50%;
  transform: translateX(-50%);
  white-space: normal;
  max-width: 250px;
  font-size: 12px;
  font-weight: 500;
  transition: opacity 0.3s ease, visibility 0.3s ease;
  pointer-events: none;
}

.custom-tooltip::after {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent #787878 transparent;
}

.tooltip-container:hover .custom-tooltip {
  visibility: visible;
  opacity: 1 !important;
}

/* Ensure tooltip is fully opaque even when parent has reduced opacity */
.search-disabled .custom-tooltip {
  opacity: 0 !important;
}

.search-disabled.tooltip-container:hover .custom-tooltip {
  opacity: 1 !important;
}
</style>
